import {LogoBanner} from '@/components/Connects/LogoBanner';
import Spinner from '@/components/Loader/Spinner';
import {PageContainer} from '@/components/PageContainer/RevisedPageContainer';
import {TeamProfile} from '@/components/TeamProfile/TeamProfile';
import {Team} from '@/user/user.interface';
import {Outlet} from 'react-router-dom';
import {Navbar} from '../components/Navbar/Navbar';

export default function CoachDirectorNavbarLayoutView({
  teamInfo,
  loading,
  showTeamProfileBar,
  role,
}: {
  teamInfo: Team | undefined;
  loading: boolean;
  showTeamProfileBar: boolean;
  role: string;
}) {
  return (
    <PageContainer>
      {loading ? (
        <div className="w-full h-screen flex items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          {!showTeamProfileBar ? (
            <>
              <LogoBanner />
              <TeamProfile teamInfo={teamInfo} role={role} />
            </>
          ) : null}

          <Outlet />
          <Navbar />
        </>
      )}
    </PageContainer>
  );
}
